<template>
  <b-navbar toggleable variant="faded" class="app-header">
    <div class="container app-header-container">
      <b-nav-toggle target="app-header-nav-collapse" class="clickable"></b-nav-toggle>
      <b-link class="navbar-brand app-brand" to="/intro" v-if="attachHome">
        <img src="/static/images/new-classting-logo.svg">
      </b-link>
      <b-link class="navbar-brand app-brand" to="/library" v-else>
        <img src="/static/images/new-classting-logo.svg">
      </b-link>

      <b-collapse is-nav id="app-header-nav-collapse">
        <b-nav is-nav-bar class="mx-auto">
          <b-nav-item to="/library">{{ $t('header.nav_menu.library') }}</b-nav-item>
          <b-nav-item to="/my-cards">{{ $t('header.nav_menu.my_cards') }}</b-nav-item>
          <b-nav-item to="/publishers" v-if="isPublisherUser">{{ $t('header.nav_menu.publishers') }}</b-nav-item>
          <b-nav-item to="/video-courses" v-if="isPublisherUser">{{ $t('header.nav_menu.video_lectures') }}</b-nav-item>
        </b-nav>
        <b-nav is-nav-bar class="hidden-sm-down">
          <a v-bind:href="userProfileUrl" target="_blank" class="btn rounded-circle profile-btn" v-bind:style="styleBindings"></a>
        </b-nav>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { CLASSTING_URL } from '@/config';

  export default {
    name: 'app-header',

    props: {
      attachHome: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      ...mapGetters([
        'isPublisherUser',
        'currentUser',
        'isKrUser',
      ]),

      userProfileUrl() {
        return `${CLASSTING_URL}/users/${this.currentUser.id}`;
      },

      styleBindings() {
        if (this.currentUser) {
          return {
            'background-image': `url('${this.currentUser.profile_image}')`,
          };
        }

        return {};
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/AppHeader.vue